// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermParameterKindEnum } from './FermParameterKindEnum';
import { fermTextInputModeEnum } from './FermTextInputModeEnum';
import { operatorId } from './Operator';
import { parameterValueSourceEnum } from './ParameterValueSourceEnum';
import { z } from 'zod';
export const fermentationParameterTypeId = (z.number());
export const fermentationParameterType = z.object({
    id: fermentationParameterTypeId,
    name: z.string(),
    code: z.string(),
    description: z.string().nullable(),
    kind: fermParameterKindEnum,
    unit: z.string().nullable(),
    min_value: z.string().nullable(),
    max_value: z.string().nullable(),
    text_input_mode: fermTextInputModeEnum.nullable(),
    text_options: z.unknown().nullable(),
    category: z.string().nullable(),
    display_order: z.number(),
    is_system: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    ramps: z.boolean(),
    value_source: parameterValueSourceEnum,
    source_attribute: z.string().nullable(),
});
export const fermentationParameterTypeInitializer = z.object({
    id: fermentationParameterTypeId.optional(),
    name: z.string(),
    code: z.string(),
    description: z.string().optional().nullable(),
    kind: fermParameterKindEnum,
    unit: z.string().optional().nullable(),
    min_value: z.string().optional().nullable(),
    max_value: z.string().optional().nullable(),
    text_input_mode: fermTextInputModeEnum.optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    category: z.string().optional().nullable(),
    display_order: z.number().optional(),
    is_system: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    ramps: z.boolean().optional(),
    value_source: parameterValueSourceEnum.optional(),
    source_attribute: z.string().optional().nullable(),
});
export const fermentationParameterTypeMutator = z.object({
    id: fermentationParameterTypeId.optional(),
    name: z.string().optional(),
    code: z.string().optional(),
    description: z.string().optional().nullable(),
    kind: fermParameterKindEnum.optional(),
    unit: z.string().optional().nullable(),
    min_value: z.string().optional().nullable(),
    max_value: z.string().optional().nullable(),
    text_input_mode: fermTextInputModeEnum.optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    category: z.string().optional().nullable(),
    display_order: z.number().optional(),
    is_system: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    ramps: z.boolean().optional(),
    value_source: parameterValueSourceEnum.optional(),
    source_attribute: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationParameterType.js.map